export enum MessageSenderType {
  Receiver = 'receiver',
  Sender = 'sender'
}
